module.exports = {"brandPurple":"rgb(94, 0, 230)","brandDark":"rgb(41, 0, 90)","brandDarker":"rgb(14, 0, 33)","brandDarkGrey":"rgb(166, 168, 170)","lightGrey":"rgb(245, 245, 245)","red":"rgb(162, 0, 45)","primary":"rgb(94, 0, 230)","secondary":"rgb(41, 0, 90)","danger":"rgb(162, 0, 45)","h1":"25px","h2":"20px","h3":"18px","h4":"18px","p":"14px","label":"14px","baseShadow":"inset 0 1px 1px rgba(0, 0, 0, 0.075) 0 0 8px rgb(94, 0, 230)"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/sass-extract-loader?{"plugins": ["sass-extract-js"]}!./app/vars.scss
// module id = ./node_modules/sass-extract-loader/index.js?{"plugins": ["sass-extract-js"]}!./app/vars.scss
// module chunks = 3